import {ObjectUtil} from '../../util/object-util';
import {Company} from './company';

export class ProposalUser {
  id: string = null;
  firstName: string = null;
  lastName: string = null;
  telephoneNumber: string = null;
  mobileNumber: string = null;
  phoneNumber: string;
  email: string = null;
  type: string = null;
  company: Company = new Company();
  profilePicture = null;

  constructor(object?: Object) {
    ObjectUtil.assign(this, object);
  }

  update(object: Partial<ProposalUser>) {
    ObjectUtil.assign(this, object);
  }
}
